import React, {useContext, useState} from 'react';
import styled from 'styled-components'
import { fontSizeL, ColorGreyDark, fontSizeS, fontWeightL, colorTeal, colorPurple, fontWeightXS, fontSizeXS, fontWeightS} from "../styles/sharedStyles"
import WorldMap from './WorldMap'
import { ChartContext } from '../context/ChartContext';
import MapFilters from './MapFilters';
import { ReactComponent as DropdownIcon } from '../assets/icons/dropdownArrow.svg'
import introLogo from '../assets/images/intro.png'
import purpleLogo from '../assets/images/purple.png'
import tealLogo from '../assets/images/teal.png'
import gif1 from '../assets/images/dndgif1.gif'
import gif2 from '../assets/images/dndgif2.gif'
import Tour from 'reactour'
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import media from '../../../../styles/MediaQueries';

const MainContainer = styled.div`
    grid-area: intro;

    display: grid;
    grid-template-columns: 35% 1fr;
    grid-template-rows: 250px 400px;
    grid-template-areas:    "title ."
                            "filter .";
    position: relative;
    color: ${ColorGreyDark};
    position: relative;
`

const TitleContainer = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    grid-area: title;
    padding: 1rem;
    background: #fff;
    text-transform: uppercase;
    line-height: 1;

    font-size: ${fontSizeL};

    img {

        max-height: 90%;
        transform: translate(-2.5rem, -3rem);

        ${media.largest`
            max-height: 80%;
            transform: translate(-2rem, -2rem);
        `}   

        ${media.large`
            max-height: 70%;
            transform: translate(-1.5rem, -1.5rem);
        `}   

        ${media.medium`
            max-height: 55%;
            transform: translate(-1rem, -1rem);
        `}   
       
    }
`

const FilterContainer = styled.div`
    grid-area: filter;

`

const TextContainer = styled.div`

    position: absolute;
    top: ${props => props.top}px;
    left: ${props => props.left}%;
    font-size: ${fontSizeS};
    width: ${props => props.width}%;
    padding-left: 1rem;

    transition: all 2s;
    z-index: 5;

    .icon {
        fill: ColorGreyDark;
        transform: rotate(180deg);
        width: 1rem;
        height: 1rem;
    }

    .button-container{
        margin-top: 2rem;
        display: flex;
        justify-content: flex-start;

        .button {
            transition: background .3s;
            background: ${props => props.color ||  "red"};
            color: #fff;
            border-radius: 3px;
            padding: .25rem .6rem .3rem .6rem;
            cursor: pointer;
            ${'' /* transform: translateX(-1rem); */}
        }
    }
`

const ButtonContainer = styled.div`
    position: absolute;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    
    bottom: 0;
    left: 1rem;
    width: 45%;

    z-index: 10;

`

const Button = styled.div`
    background-color: ${props => props.color};
    border-radius:3px;
    display:inline-block;
    cursor:pointer;
    color:#ffffff;
    font-size: ${fontSizeS};
    font-weight: ${fontWeightS};
    padding: .8rem 1.5rem;
    text-decoration:none;
    margin-right: 3rem;

    &:hover{
        background-color: ${props => props.color};
    }

    &:active{
        position:relative;
        top:1px;
    }
`

const MapContainer = styled.div`
    position: absolute;
    left: ${props => props.left}%;
    top: ${props => props.top}px;

    width: ${props => props.width}%;
    height: ${props => props.height}px;
    transition: all 2s;
`

const ColoredSpan = styled.span`
    color: ${props => props.color || ColorGreyDark};
    font-weight: ${fontWeightL};
`

const TourDiv = styled.div`
    font-family: neue-kabel, sans-serif;
    color: ${ColorGreyDark};

    .unselect-icon {
        font-weight: ${fontWeightXS};
        font-size: ${fontSizeXS};
    }

    .bold {
        font-weight: ${fontWeightL};
    }

    .hrds-span {
        color: ${colorTeal};
    }

    .les-span {
        color: ${colorPurple};
    }

    .gif-container {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: ${props => props.gifMarginTop || 0}px;
        img {
            max-width: ${props => props.gifWidth}%;
        }
    }
`


const IntroContainer = () => {

    const { setPosition, position, setPath, path, 
            displayedMetrics, setDisplayedMetrics, 
            filterQuestions, setFiltersQuestions,
            chartQuestions, setChartQuestions,
            hideFilters, setHideFilters,
            filtersAppliedToggle, setFiltersAppliedToggle } = useContext(ChartContext)
    const [ isTourOpen, setIsTourOpen ] = useState(false)
    const left = position === 'left'
    const titleImg = path === "both" ? introLogo : path === "hrds" ? tealLogo : purpleLogo
    const accentColor = path === "hrds" ? colorTeal : colorPurple

    const disableBody = target => disableBodyScroll(target);
    const enableBody = target => enableBodyScroll(target);

    const closeTour = () => {
        setIsTourOpen(false);
      };
    
    const openTour = () => {
        setIsTourOpen(true)
    };

    const addFilterChartQuestion = () => {
        if(filterQuestions.length === 0){
            const firstQuestions = displayedMetrics.slice(0,2)
            const firstQids = firstQuestions.map(el => el.qid)
            setFiltersQuestions([...firstQuestions])
            setDisplayedMetrics([...displayedMetrics.filter(el => firstQids.includes(el.qid))])
        }
        if(chartQuestions.length === 0){
            const firstQuestions = displayedMetrics.slice(4,8)
            const firstQids = firstQuestions.map(el => el.qid)
            setChartQuestions([...firstQuestions])
            setDisplayedMetrics([...displayedMetrics.filter(el => firstQids.includes(el.qid))])
        }
    }

    const tourConfig = [
        {
          selector: '[data-tut="svg-map"]',
          content: () => {
            return (
            <TourDiv>
              Let's start with the world map, 
              where you can filter countries in or out by clicking on them! 
              Also, you can get some extra information with the help of the 
              tooltip by hovering over! Go ahead and give it a try! 😉
            </TourDiv>)
          },
          style: {
            fontFamily: "neue-kabel, sans-serif"
          },
          action: () => {
            setFiltersAppliedToggle(false)
        },
        },
        {
          selector: '[data-tut="country-filter"]',
          content: () => {
            return (<TourDiv>
              Of course, you can always use this region and country dropdown to make setting 
              your selection easier! Also, take a quick look at the respondent-counter here. It will 
              always give you information about how many respondents' 
              answers you are currently analyzing. 
              Try filtering away one of the regions with the little 
              <span className="unselect-icon">
                &nbsp;✕&nbsp;
              </span>
              to see how it changes!
            </TourDiv>)
        },
          action: () => {
            setFiltersAppliedToggle(false)
        },
        },
        {
            selector: '[data-tut="metrics-container"]',
            content: () => {
                if(hideFilters){
                    setHideFilters(false)
                }
                return (<TourDiv>
                    And here we are, all the questions that you have available for the analysis! 
                    There are more than 
                    <span className="hrds-span bold">
                        {' '}50 for Human Rights Defenders{' '}
                    </span> 
                    and 
                    <span className="les-span bold">
                    &nbsp;almost 40 for Legal Experts&nbsp;
                    </span>
                    covering topcis from Security Environment, 
                    Demographics, Political Rights and many more! 
                    You can use the search bar above the container to look for
                    question content or type (e.g. Demographics).
                    Any of these questions can serve either as a filter or
                    to be visualized with a chart for your analysis! 
                    Let's see on the next slide how!
                </TourDiv>)
            },
            action: () => {
                setFiltersAppliedToggle(false)
            },
            stepInteraction: false
        },
        {
            selector: '[data-tut="filter-elements"]',
            content: () => {
            if(hideFilters){
                setHideFilters(false)
            }
              return (
                <TourDiv
                    gifWidth={80}
                >
                    So you can drag-and-drop any of the questions to use its answers
                    as filters!
                    <div className="gif-container">
                        <img src={gif1} alt="drag and drop example one"/>
                    </div>
                    Easy, right? 😏 For some extra information about the expected
                    respondents numbers just hover over any of the answers. 
                    Also, you can easily remove the question from the 
                    list by clicking on its title!
                </TourDiv>)
            },
            action: () => {
                addFilterChartQuestion()
                setFiltersAppliedToggle(false)
            },
            position: "center"
        },
        {
            selector: '[data-tut="chart-elements"]',
            content: () => {
                return (
                <TourDiv
                    gifWidth={100}
                    gifMarginTop={5}
                >
                    The same way you could drag-and-drop any of the
                    survey questions to the filter panel, you can just as
                    easily do the same when wanting to display them
                    as a chart!
                    <div className="gif-container">
                        <img src={gif2} alt="drag and drop example two"/>
                    </div>
                </TourDiv>)
            },
            action: () => {
                addFilterChartQuestion()
                setFiltersAppliedToggle(false)
            },
            position: "center"
        },
        {
            selector: '[data-tut="chart-toggle"]',
            content: () => {
              return (
                <TourDiv>
                    After having added all the desired filter questions, 
                    you can make the visualisation
                    easier to read by expanding the chart area by clicking on the icon!
                </TourDiv>)
            },
            action: () => {
                addFilterChartQuestion()
                setFiltersAppliedToggle(false)
            }
        },
        {
            selector: '[data-tut="chart-elements"]',
            content: () => {
                const message = hideFilters
                ? "You see? Now we have much more space for both the labels and the tooltips! ☺️"
                : "Also, you can again just put back any question to the collection by clicking on its title!"
                return (
                <TourDiv>
                    {message}
                </TourDiv>)
            },
            action: () => {
                addFilterChartQuestion()
                setFiltersAppliedToggle(false)
            }
        },
        {
            selector: '[data-tut="chart-dropdown-list"]',
            content: () => {
                if(!filtersAppliedToggle){
                    setFiltersAppliedToggle(true)
                }
                addFilterChartQuestion()
                return (
                    <TourDiv>
                        When the chart area is expanded,
                        even though you have hidden the 
                        filter questions, with the help of the
                        <span className="bold">
                            {' '}Filters Control{' '} 
                        </span>
                        dropdown you can still have easy access to them!
                    </TourDiv>)
            }
        },
        {
            selector: '[data-tut="fixed-control"]',
            content: () => {
                if(filtersAppliedToggle){
                    setFiltersAppliedToggle(false)
                }
                if(hideFilters){
                    setHideFilters(false)
                }
                return (
                    <TourDiv>
                       To keep our secret weapon for the very end,
                       with this little fixed control, you can facilitate
                       the toggle between analyzing the answers from 
                       <span className="hrds-span bold">
                            {' '}Human Rights Defenders{' '}
                        </span> 
                        and 
                        <span className="les-span bold">
                            &nbsp;Legal Experts&nbsp;
                        </span>.
                        And don't worry, your changes will be
                        saved for the next time or toggle - unless you reset all,
                        because you have to power to do that too! 😎
                        Happy analyzing! 🧐
                    </TourDiv>)
            }
        }
    ];

    return ( 
        <>
            <MainContainer
                column={left ? 40 : 30}
            >
                <TitleContainer>
                    <img src={titleImg} alt="Title: Hear their voices"/>
                </TitleContainer>
                <FilterContainer>
                    <MapFilters/>
                </FilterContainer>
                <TextContainer
                    top={left ? 240 : 10}
                    left={left ? 0 : 35}
                    width={left ? 40 : 30}
                >
                    Justice and Peace Netherlands, a non-profit organisation based in 
                    The Hague, has committed itself to empower local change makers to 
                    help them in their fight for more human rights and social justice for all.
                    Since last year, it has collected individual responses from 
                    <ColoredSpan color={colorTeal}>{' '}269 Human Rights Defenders{' '}</ColoredSpan> (HRDs)
                     alongside with 
                    <ColoredSpan color={colorPurple}>{' '}72 Legal Experts{' '}</ColoredSpan> (LEs) 
                     from over 60 countries across the globe.
                </TextContainer>
                <TextContainer
                    top={left ? 425 : 10}
                    left={left ? 0 : 70}
                    width={left ? 40 : 30}
                    color={accentColor}
                >
                    <div>
                        The following visualisation intents to help you better understand 
                        what are the main challenges that these vital individuals face day-by-day 
                        at the very frontlines
                        of promoting respect for human rights and social justice.

                        { path === "both" 
                            ? 
                            <>
                            {' '}You can already start discovering by hovering over 
                             the countries on the globe!
                                Then please go ahead and choose 
                                the respondent group you would like to analyze!
                            </>
                            :
                            <div className="button-container">
                                <div/>
                                <div 
                                    className="button"
                                    onClick={openTour}
                                >
                                    How to use?
                                </div>
                            </div>
                        }
                    </div>
                </TextContainer>
                <Tour
                    onRequestClose={closeTour}
                    steps={tourConfig}
                    isOpen={isTourOpen}
                    maskClassName="mask"
                    className="helper"
                    rounded={3}
                    accentColor={accentColor}
                    onAfterOpen={disableBody}
                    onBeforeClose={enableBody}
                />
                {path === 'both' &&
                    <ButtonContainer>
                        <Button
                            color={colorTeal}
                            onClick={() => {
                                setPosition(prevPos => prevPos === 'left' && 'right')
                                setPath('hrds')
                            }}
                        >
                            Human Rights Defenders
                        </Button>
                        <Button
                            color={colorPurple}
                            onClick={() => {
                                setPosition(prevPos => prevPos === 'left' && 'right')
                                setPath('les')
                            }}
                        >
                            Legal Experts
                        </Button>
                    </ButtonContainer>
                }
                <MapContainer
                    top={left ? 0 : 250}
                    height={left ? 650 : 400}
                    left={left ? 45 : 35}
                    width={left ? 55 : 65}
                >   
                    <WorldMap/>
                </MapContainer>
            </MainContainer>
        </>
     );
}
 
export default IntroContainer;